import { render } from "./HeaderKlein.vue?vue&type=template&id=62720540&scoped=true"
import script from "./HeaderKlein.vue?vue&type=script&lang=js"
export * from "./HeaderKlein.vue?vue&type=script&lang=js"

import "./HeaderKlein.vue?vue&type=style&index=0&id=62720540&scoped=true&lang=scss"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62720540"]])

export default __exports__